import { Bonomove } from "./bonomove";
import { Cliente } from "./cliente";
import { Evento } from "./evento";

export class Ticket {
  id!: number;
  cliente!: Cliente;
  event!: Evento;
  totalSinIva!: number;
  totalIva!: number;
  ivaAplicado!: number;
  total!: number;
  info!: string | null;
  conEfectivo!: boolean;
  conTarjeta!: boolean;;
  importeEfectivo!: number;
  importeTarjeta!: number;
  totalAPagar!: number;
  efectivoEntregado!: number;
  cambioDevuelto!: number;
  tiendaId!: number;
  dia!: Date;
  importeFinanciado!: number;
  importeOtros!: number;
  conOtros!: boolean;
  bonomoves!: Bonomove[] | null;
  fechaAlta!: Date | null;

  constructor(init?: Partial<Ticket>) {
    Object.assign(this, init);
  }
}

export class TicketsAccionCaja {
  tickets!: Ticket[];
  totalSum: number;
  descuentosSum: number;
  totalPagarSum: number;
  efectivoSum: number;
  tarjetaSum: number;
  otrosSum: number;

  constructor(init?: Partial<TicketsAccionCaja>) {
    Object.assign(this, init);
  }
}

export interface RegisterTicket {
  id?: number;
  eventId: number;
  clienteId: number;
  userId: number;
  tiendaId: number;
  servicios: RegisterTicketServicio[];
  productos: RegisterTicketProducto[];
  bonosAplicados: RegisterTicketBono[];
  total: number;
  totalPagar: number;
  importeFinanciado: number;
  totalIva: number;
  totalSinIva: number;
  ivaAplicado: number;
  // Campos de pago
  conEfectivo?: boolean;
  conTarjeta?: boolean;
  conOtros?: boolean;
  importeEfectivo?: number;
  importeTarjeta?: number;
  importeOtros?: number;
  efectivoEntregado?: number;
  cambioDevuelto?: number;
}

export interface RegisterTicketServicio {
  servicioId: number;
  cantidad: number;
  precioUnitario: number;        // precio base del servicio
  precioCobrado: number;         // precio que se cobra ahora (puede ser diferente si está financiado)
  financiado: boolean;
  numPlazos?: number;            // número de plazos si está financiado
  precioPlazo?: number;          // precio por plazo si está financiado
  bonoclienteId?: number;
  descuentoBono: number;
  sesionesGastadas?: number;
  userId?: number;               // usuario que realiza el servicio
}

export interface RegisterTicketProducto {
  productoId: number;
  cantidad: number;
  precioUnitario: number;        // precio unitario del producto
  userId?: number;               // usuario que realizó la venta del producto
}

export interface RegisterTicketBono {
  bonoclienteId: number;
  eurosGastados?: number;
  sesionesGastadas?: number;
}


